// Partner + Customer lists: A→Z by name, or by Users / Status / Partner Success / Parent partner.
// Clicking a sortable header shows the most useful rows first; clicking it again returns to A→Z.
import { useMemo, useState } from "react";

const collator = new Intl.Collator("en", { sensitivity: "base", numeric: true });
const STATUS_RANK = { active: 0, suspended: 1, deactivated: 2, archived: 3 };
// Assigned rows first (grouped A→Z by the person/partner), unassigned last.
const byOwner = (field) => (a, b) => Number(!a[field]) - Number(!b[field]) || collator.compare(a[field] || "", b[field] || "");

const CMP = {
  users: (a, b) => (b.user_count || 0) - (a.user_count || 0),
  status: (a, b) => (STATUS_RANK[a.status] ?? 9) - (STATUS_RANK[b.status] ?? 9),
  partner_success: byOwner("partner_success_name"),
  parent: byOwner("parent_org_name"),
};

export function useOrgSort(rows) {
  const [sort, setSort] = useState(null);   // null = A→Z by name
  const toggle = (key) => setSort((s) => (s === key ? null : key));
  const sorted = useMemo(() => {
    const cmp = CMP[sort];
    return [...(rows || [])].sort((a, b) => (cmp && cmp(a, b)) || collator.compare(a.name || "", b.name || ""));
  }, [rows, sort]);
  return { sorted, sort, toggle };
}
